import { Union } from 'ts-toolbelt';

import { InitialValues } from 'forms/types';

import { PolicyFeaturesFormValues } from '../form/types';
import { GetPolicyFeaturesQuery } from '../graphql/GetPolicyFeatures';

const buildInitialValues = (
  data: Union.Nullable<GetPolicyFeaturesQuery>
): InitialValues<PolicyFeaturesFormValues> => ({
  ownOccupationPolicy: data?.surveyPolicyFeatures.ownOccupationPolicy ?? true,
  residualDisabilityPolicy: data?.surveyPolicyFeatures.residualDisabilityPolicy ?? true,
  noncancellable: data?.surveyPolicyFeatures.noncancellable ?? true,
});

export default buildInitialValues;
